var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDelete = function SvgDelete(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 11,
    "data-width-24": 17,
    viewBox: "0 0 11 12",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.77 2.215V1.57A1.57 1.57 0 0 1 4.338 0h2.215a1.57 1.57 0 0 1 1.57 1.57v.645h2.307a.462.462 0 0 1 0 .924h-.646v7.292A1.57 1.57 0 0 1 8.215 12H2.677a1.57 1.57 0 0 1-1.539-1.57V3.14H.462a.462.462 0 0 1 0-.924H2.77m4.43 0H3.692l.031-.615A.615.615 0 0 1 4.34.985h2.246A.615.615 0 0 1 7.2 1.6zm-5.139.924h6.8v7.292a.615.615 0 0 1-.646.646H2.677a.614.614 0 0 1-.615-.646zM6.555 9.23a.47.47 0 0 1-.462-.462V5.446a.462.462 0 1 1 .923 0V8.77a.47.47 0 0 1-.461.462m-2.54-.137a.47.47 0 0 0 .324.137.47.47 0 0 0 .462-.462V5.446a.462.462 0 0 0-.923 0V8.77c.001.122.05.239.137.325",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDelete);
export default ForwardRef;